<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>

    export default {
    mounted () {
      this.$nextTick(function(){
        document.body.className=document.body.className.replace('initloading','')
      })
    }
  }
</script>

<style>
/* ============================================ *
   * 重置样式模块
   * ============================================ */
    
html,body,#app{
  height: 100%
}
html {
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  font-size: 62.5%; }

body {
  margin: 0;
  font-size: 1.4rem;
  line-height: 1.5;
  color: #333333;
}

article, aside, details, figcaption, figure, footer, header, hgroup, main, nav, section, summary {
  display: block; }

audio, canvas, progress, video {
  display: inline-block;
  vertical-align: baseline; }

audio:not([controls]) {
  display: none;
  height: 0; }

[hidden], template {
  display: none; }

svg:not(:root) {
  overflow: hidden; }

a {
  background: transparent;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  color: #0088cc; }

a:active {
  outline: 0; }

a:active {
  background-color: rgba(0, 0, 0, 0); }

abbr[title] {
  border-bottom: 1px dotted; }

b, strong {
  font-weight: bold; }

dfn {
  font-style: italic; }

mark {
  background: #ff0;
  color: #000; }

small {
  font-size: 80%; }

sub, sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline; }

sup {
  top: -0.5em; }

sub {
  bottom: -0.25em; }

img {
  border: 0;
  vertical-align: middle; }

hr {
  height: 0; }

pre {
  overflow: auto;
  white-space: pre;
  white-space: pre-wrap;
  word-wrap: break-word; }

code, kbd, pre, samp {
  font-family: monospace,monospace;
  font-size: 1em; }

button, input, optgroup, select, textarea {
  color: inherit;
  font: inherit;
  margin: 0; }

button {
  overflow: visible; }

button, select {
  text-transform: none; }

button, html input[type="button"], input[type="reset"], input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer; }

button[disabled], html input[disabled] {
  cursor: default; }

button::-moz-focus-inner, input::-moz-focus-inner {
  border: 0;
  padding: 0; }

input {
  line-height: normal; }

input[type="checkbox"], input[type="radio"] {
  padding: 0; }

input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  height: auto; }

input[type="search"] {
  -webkit-appearance: textfield; }

input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; }

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em; }

legend {
  border: 0;
  padding: 0; }

textarea {
  overflow: auto;
  resize: vertical; }

optgroup {
  font-weight: bold; }

table {
  border-collapse: collapse;
  border-spacing: 0; }

td, th {
  padding: 0; }

html, button, input, select, textarea {
  font-family: "Helvetica Neue",Helvetica,STHeiTi,Arial,sans-serif; }

h1, h2, h3, h4, h5, h6, p, figure, form, blockquote {
  margin: 0; }

ul, ol, li, dl, dd {
  margin: 0;
  padding: 0; }

ul, ol {
  list-style: none outside none; }

h1, h2, h3 {
  line-height: 2;
  font-weight: normal; }

h1 {
  font-size: 1.8rem; }

h2 {
  font-size: 1.6rem; }

h3 {
  font-size: 1.4rem; }

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #cccccc; }

/*input:focus::-webkit-input-placeholder{color:#EEEEEE;}*/
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box; }

/*# sourceMappingURL=init.css.map */


@font-face {
  font-family: 'iconfont';  /* project id 86139 */
  src: url('//at.alicdn.com/t/font_l2qd42w10glanhfr.eot');
  src: url('//at.alicdn.com/t/font_l2qd42w10glanhfr.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_l2qd42w10glanhfr.woff') format('woff'),
  url('//at.alicdn.com/t/font_l2qd42w10glanhfr.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_l2qd42w10glanhfr.svg#iconfont') format('svg');
}

.icon {
  font-family:"iconfont" !important;
  font-size:16px;
  font-style:normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
.icon-arrowdown:before { content: "\e603"; }
.icon-succeed:before { content: "\e619"; }

</style>
